var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDisclaimerWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "DisclaimerWarning_svg__a",
  width: 20,
  height: 20,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h20v20H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#DisclaimerWarning_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M2.854 17.083a.73.73 0 0 1-.643-.377.8.8 0 0 1-.107-.364.7.7 0 0 1 .106-.39L9.344 3.63A.75.75 0 0 1 10 3.253q.192 0 .366.092a.75.75 0 0 1 .29.285l7.134 12.323a.7.7 0 0 1 .105.389.8.8 0 0 1-.107.364.73.73 0 0 1-.643.377zm.854-1.25h12.584L10 5zM10 14.839q.285 0 .48-.193a.65.65 0 0 0 .193-.48q0-.285-.194-.48a.65.65 0 0 0-.48-.193q-.285 0-.479.194a.65.65 0 0 0-.193.48q0 .285.193.479.195.193.48.193m0-2.18q.266 0 .445-.179.18-.18.18-.445V9.118a.6.6 0 0 0-.18-.445.6.6 0 0 0-.445-.18.6.6 0 0 0-.446.18.6.6 0 0 0-.18.445v2.917q0 .265.18.445t.446.18"
}))));
export default SvgDisclaimerWarning;